{
  "workManagement": "CMMS",
  "preventiveMaintenance": "Preventive Maintenance",
  "analytics": "Analytics",
  "procedures": "Procedures",
  "branding": "Branding",
  "customerPortal": "Customer Portal",
  "customerPortalHierarchy": "Customer Portal Hierarchy",
  "teams": "Teams",
  "emails": "Emails",
  "_3DModels": "3D Models",
  "activityLogging": "Activity Logging",
  "aiAssistants": "AI Assistants",
  "scheduler": "Scheduler",
  "calendarSync": "Calendar Sync",
  "aiNotetaker": "AI Notetaker",
  "hierarchy": "Hierarchy",
  "aiSearch": "AI Search",
  "aiSearchSummary": "AI Search Summary",
  "inventoryStockManagement": "Inventory Stock Management",
  "quotesAndInvoices": "Quotes & Invoices",
  "voiceQuery": "Voice Query"
}
